export default __webpack_public_path__ + "static/media/step3.679de96a.png";